import { useEffect, useRef, useState } from 'react'

export const useImageDownload = (props: {
  url: string | null | undefined
  retryCount?: number
  retryDelayMs?: number
  placeholder?: string
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const attemptsRemaining = useRef(props.retryCount || 0)
  const retryTimeout = useRef<NodeJS.Timeout | null>(null)

  const load = (targetUrl: string) => {
    const img = new Image()
    img.src = targetUrl

    img.onload = () => {
      setIsLoaded(true)
    }

    img.onerror = () => {
      if (attemptsRemaining.current <= 0) {
        return
      }

      attemptsRemaining.current -= 1

      retryTimeout.current = setTimeout(() => {
        load(targetUrl)
      }, props.retryDelayMs)
    }

    return img
  }

  useEffect(() => {
    if (!props.url) {
      return
    }

    setIsLoaded(false)
    attemptsRemaining.current = props.retryCount || 0

    const img = load(props.url)

    return () => {
      img.onload = null
      img.onerror = null

      if (retryTimeout.current) {
        clearTimeout(retryTimeout.current)
        retryTimeout.current = null
      }
    }
  }, [props.url])

  return {
    isLoaded,
    image: isLoaded ? props.url || undefined : props.placeholder,
  }
}
